import { FunctionComponent, useEffect, useState } from "react";
import { IssuerConfigCreations } from "../utils/helpers/types";
import styles from "./self-service.module.scss";
import { resources } from "../utils/resources";
import Modal from "../components/modal/Modal";

interface issuerConfigEditModalProps {
  issuerConfig: IssuerConfigCreations | null;
  cancel: () => void;
  visible: boolean;
}

const IssuerConfigViewModal: FunctionComponent<issuerConfigEditModalProps> = ({
  issuerConfig: _issuerConfig,
  cancel,
  visible
}) => {
  const [loading] = useState(false);
  const [issuerConfig, setIssuerConfig] =
    useState<IssuerConfigCreations | null>(_issuerConfig);

  useEffect(() => {
    setIssuerConfig(_issuerConfig);
  }, [_issuerConfig]);

  const formatDate = (date: string): string => {
    const formattedDate = new Date(date)
      .toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      })
      .replace(/\//g, "-");
    return formattedDate;
  };

  return (
    <Modal visible={visible} cancel={cancel} ignoreBackdropClicks>
      {loading ? (
        <img
          alt="loading"
          src={resources.images.LOADING_TYPING}
          className="generic-icon xxl"
        />
      ) : (
        <section className={styles.details}>
          <div className={styles.detail}>
            <span className={styles.key}>Id:</span>
            <span className={styles.value}>{issuerConfig?.id || "N/A"}</span>
          </div>

          <div className={styles.detail}>
            <span className={styles.key}>Name:</span>
            <span className={styles.value}>{issuerConfig?.name || "N/A"}</span>
          </div>

          <div className={styles.detail}>
            <span className={styles.key}>Issuer Code:</span>
            <span className={styles.value}>
              {issuerConfig?.issuerCode || "N/A"}
            </span>
          </div>

          <div className={styles.detail}>
            <span className={styles.key}>Created by:</span>
            <span className={styles.value}>
              {issuerConfig?.createdBy || "N/A"}
            </span>
          </div>

          <div className={styles.detail}>
            <span className={styles.key}>Created on:</span>
            <span className={styles.value}>
              {issuerConfig?.createdOn
                ? formatDate(issuerConfig.createdOn)
                : "N/A"}
            </span>
          </div>

          <div className={styles.detail}>
            <span className={styles.key}>Wallet ID:</span>
            <span className={styles.value}>
              {issuerConfig?.walletId || "N/A"}
            </span>
          </div>

          <div className={styles.detail}>
            <span className={styles.key}>Api Version:</span>
            <span className={styles.value}>
              {issuerConfig?.apiVersion || "N/A"}
            </span>
          </div>

          <div className={styles.detail}>
            <span className={styles.key}>Last updated on:</span>
            <span className={styles.value}>
              {issuerConfig?.lastUpdatedOn
                ? formatDate(issuerConfig.lastUpdatedOn)
                : "N/A"}
            </span>
          </div>

          <div className={styles.detail}>
            <span className={styles.key}>Last updated by:</span>
            <span className={styles.value}>
              {issuerConfig?.lastUpdatedBy || "N/A"}
            </span>
          </div>

          <div className={styles.detail}>
            <span className={styles.key}>Additional fields:</span>
            <span className={styles.value}>
              {issuerConfig?.additionalFields || "N/A"}
            </span>
          </div>

          <div className={styles.detail}>
            <span className={styles.key}>Security:</span>
            <span className={styles.value}>
              {issuerConfig?.security || "N/A"}
            </span>
          </div>
        </section>
      )}
    </Modal>
  );
};
export default IssuerConfigViewModal;
